import React, { useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { Building2, Unlink } from 'lucide-react'
import { tr } from 'i18n'
import { hasAccess } from 'utils/access'
import { assignDriverBase, changeDriverBase, removeDriverBase } from 'service/AdminPanelService'
import { getErpErrorMessage } from 'service/ErpService'
import DriverBaseDialog from '../DriverBaseDialog/DriverBaseDialog.tsx'
import s from '../Management.module.scss'

export default function DriverBaseActions({ driver, onChanged = () => {}, showAvailabilityHint = true }: any) {
  useTranslation()
  const user = useSelector((state: any) => state.user)
  const [confirmation, setConfirmation] = useState<any>(null)
  const [busy, setBusy] = useState(false)
  const busyRef = useRef(false)
  const [error, setError] = useState('')
  const [message, setMessage] = useState('')
  const assigned = ['top_base', 'chpp', 'private_point'].some(type => driver[type] != null)
  const canSetBase = hasAccess(user, assigned ? 'drivers_base_change' : 'drivers_base_assign')
  const canRemoveBase = assigned && hasAccess(user, 'drivers_base_remove')
  const available = ['', 'Свободен', 'Простаивает', 'free', 'idle'].includes(driver.status || '') && !driver.integration_active_load
  if (!canSetBase && !canRemoveBase) return null

  const open = (mode: string) => {
    setError(''); setMessage('')
    setConfirmation({ mode, driver: { ...driver } })
  }
  const confirm = async (baseType: string, baseId: number | null, pin: string) => {
    if (busyRef.current || !confirmation || !/^[0-9]{4}$/.test(pin)) return
    const { mode, driver: expectedDriver } = confirmation
    busyRef.current = true
    setBusy(true); setError(''); setMessage('')
    try {
      if (mode === 'remove') await removeDriverBase(driver.id, pin, expectedDriver)
      else if (mode === 'change') await changeDriverBase(driver.id, baseType, baseId, pin, expectedDriver)
      else await assignDriverBase(driver.id, baseType, baseId, pin, expectedDriver)
      setConfirmation(null)
      setMessage(tr(mode === 'remove' ? 'Транспорт снят с базы.' : mode === 'change' ? 'База изменена.' : 'База назначена.'))
      await onChanged()
    } catch (failure) {
      setError(getErpErrorMessage(failure, tr('Не удалось изменить базу транспорта.')))
    } finally {
      busyRef.current = false
      setBusy(false)
    }
  }
  return <div onClick={event => event.stopPropagation()}>
    <div className={s.actions}>
      {canSetBase && <button type="button" className={s.button} disabled={busy || !available}
        onClick={() => open(assigned ? 'change' : 'assign')}>
        <Building2 size={14} aria-hidden="true" />{tr(assigned ? 'Сменить базу' : 'Назначить базу')}
      </button>}
      {canRemoveBase && <button type="button" className={s.button} disabled={busy || !available} onClick={() => open('remove')}>
        <Unlink size={14} aria-hidden="true" />{tr('Снять с базы')}
      </button>}
    </div>
    {showAvailabilityHint && !available && <p className={s.muted}>{tr('Смена водителя, работа с базой, доступна, когда транспорт свободен или простаивает.')}</p>}
    {message && <p role="status" className={s.muted}>{message}</p>}
    {!confirmation && error && <p role="alert" className={s.error}>{tr(error)}</p>}
    {confirmation && <DriverBaseDialog key={`${driver.id}-${confirmation.mode}`} driver={confirmation.driver} mode={confirmation.mode}
      busy={busy} error={error} onClose={() => { if (!busyRef.current) setConfirmation(null) }} onConfirm={confirm} />}
  </div>
}
